import type { PocInputValidity } from 'commons/types';
import type { FieldCustomError } from 'core/types/field-errors.type';

export type TrainingRegistrationAPI = {
    id?: string;
    externalId: string;
    name: string;
    active: boolean;
};

export type TrainingRegistration = {
    index: number;
    id?: string;
    externalId?: string;
    name?: string;
    active: boolean;
};

export type TrainingRegistrationValidation = {
    externalId?: PocInputValidity;
    name?: PocInputValidity;
};

export type TrainingRegistrationCustomErrors = {
    externalId?: FieldCustomError[];
    name?: FieldCustomError[];
};

export const defaultTrainingRegistrationCustomErrors: TrainingRegistrationCustomErrors = {
    externalId: undefined,
    name: undefined,
};

export const defaultTrainingRegistrationValidition: TrainingRegistrationValidation = {
    externalId: undefined,
    name: undefined,
};

export const newTrainingRegistration = (
    index: number,
    active: boolean = true,
    externalId?: string,
    name?: string
): TrainingRegistration => ({
    index,
    active,
    externalId,
    name,
});

export const isValidMapping = (trainingRegistrations: TrainingRegistration[]): boolean =>
    !trainingRegistrations.some((tr) => !tr.externalId || !tr.name);

export const mapTrainingRegistrationFromModelToAPI = (
    trainingRegistrations: TrainingRegistration[]
): TrainingRegistrationAPI[] =>
    trainingRegistrations.map((tr) => ({ id: tr.id, externalId: tr.externalId!, name: tr.name!, active: tr.active }));

export const mapTrainingRegistrationFromAPIToModel = (
    trainingRegistrations?: TrainingRegistrationAPI[]
): TrainingRegistration[] =>
    trainingRegistrations?.map((tr, index) => ({
        index,
        id: tr.id,
        externalId: tr.externalId,
        name: tr.name,
        active: tr.active,
    })) ?? [];

export const areTrainingRegistrationEquals = (tr1: TrainingRegistration, tr2: TrainingRegistration) =>
    tr1.name === tr2.name && tr1.externalId === tr2.externalId && tr1.active === tr2.active;
